import { renderPrintDocument } from "../../core/renderPrintDocument";
import { escapeHtml } from "../../shared/escapeHtml";
import { officialDocumentStyles } from "../../shared/officialDocumentStyles";
import { createSlopPrintViewModelV2 } from "./createSlopPrintViewModelV2";

const slopStylesV2 = `
  ${officialDocumentStyles}

  .slop-table th:nth-child(2),
  .slop-table th:nth-child(3),
  .slop-table th:nth-child(4),
  .slop-table td:nth-child(2),
  .slop-table td:nth-child(3),
  .slop-table td:nth-child(4) {
    text-align: center;
  }
`;

const rows = [
  { label: "UTI Ullage", key: "uti-ullage" },
  { label: "Corr Ullage", key: "corr-ullage" },
  { label: "GOV (m3)", key: "gov-(m3)" },
  { label: "Last Cargo", key: "last-cargo" },
  { label: "UTI Interface", key: "uti-interface" },
  { label: "Corr Interface", key: "corr-interface" },
  { label: "Water GOV", key: "water-gov" },
];

const formatValue = (value) => (value === undefined || value === null || value === "" ? "\u2014" : String(value));

const renderSlopBody = (model) => `
  <main class="official-document">
    <header class="official-header">
      <div class="official-logo-wrap">
        ${
          model.companyLogo
            ? `<img src="${escapeHtml(model.companyLogo)}" alt="Company logo" class="official-logo" />`
            : ""
        }
      </div>
      <div class="official-header-main">
        <h1 class="official-vessel-name">${escapeHtml(model.vesselName)}</h1>
        <h2 class="official-title">${escapeHtml(model.title)}</h2>
      </div>
    </header>

    <hr class="official-rule" />

    <table class="official-meta" aria-label="Document metadata">
      <tbody>
        <tr>
          <td class="official-meta-label">Voy:</td>
          <td class="official-meta-value">${escapeHtml(model.voyageNumber)}</td>
          <td class="official-meta-label">Date:</td>
          <td class="official-meta-value">${escapeHtml(model.date)}</td>
        </tr>
        <tr>
          <td class="official-meta-label">Port:</td>
          <td class="official-meta-value">${escapeHtml(model.portName)}</td>
          <td class="official-meta-label">Berth:</td>
          <td class="official-meta-value">${escapeHtml(model.berthName)}</td>
        </tr>
        <tr>
          <td class="official-meta-label">Condition:</td>
          <td class="official-meta-value">${escapeHtml(model.condition)}</td>
          <td class="official-meta-label">Draft:</td>
          <td class="official-meta-value">${escapeHtml(
            `FWD ${formatValue(model.draft.forward)} m | AFT ${formatValue(model.draft.aft)} m | Trim ${formatValue(model.trim)} m`
          )}</td>
        </tr>
      </tbody>
    </table>

    <hr class="official-meta-separator" />

    <section class="official-section">
      <table class="official-table slop-table">
        <thead>
          <tr>
            <th>Measurements</th>
            <th>Deck Drain Tank P</th>
            <th>Deck Drain Tank S</th>
            <th>Cargo (Slop-tank) 1S</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          ${rows
            .map((row) => {
              const measurement = model.measurements[row.key] || {};
              return `
                <tr>
                  <td>${escapeHtml(row.label)}</td>
                  <td>${escapeHtml(formatValue(measurement.p))}</td>
                  <td>${escapeHtml(formatValue(measurement.s))}</td>
                  <td>${escapeHtml(formatValue(measurement.cargo))}</td>
                  <td>${escapeHtml(formatValue(measurement.remarks))}</td>
                </tr>
              `;
            })
            .join("")}
        </tbody>
      </table>
      <div class="official-box">
        <div class="official-emphasis">Remarks</div>
        <p class="official-note">${escapeHtml(formatValue(model.remarks))}</p>
      </div>
    </section>

    <section class="official-signatures">
      <div class="official-signature-block">
        <div class="official-signature-line"></div>
        <div class="official-signature-caption">
          <div>Ship's representative</div>
          <div class="official-signature-name">Chief Officer</div>
        </div>
      </div>
      <div class="official-signature-block">
        <div class="official-signature-line"></div>
        <div class="official-signature-caption">
          <div>Surveyor / Load Master</div>
          <div class="official-signature-name">Name in block letters</div>
        </div>
      </div>
    </section>
  </main>
`;

export const renderSlopV2 = (input) => {
  const model = createSlopPrintViewModelV2(input);

  return renderPrintDocument({
    title: model.title,
    templateId: "slop",
    viewModel: model,
    styles: slopStylesV2,
    body: renderSlopBody(model),
  });
};
